import react1 from '../assets/icons/react1.svg';
import html from '../assets/icons/html.svg';
import css from '../assets/icons/css.svg';
import sass from '../assets/icons/sass.svg';
import material from '../assets/icons/material.svg';
import javascript from '../assets/icons/javascript.svg';
import figma from '../assets/icons/figma2.svg';
import git from '../assets/icons/git.svg';
import redux from '../assets/icons/redux.svg';
import router from '../assets/icons/router.svg';
import axios from '../assets/icons/axios.svg';
import bootstrap from '../assets/icons/bootstrap.svg';

const languages = [
  {
    icon: html,
    name: 'HTML5',
    level: '100',
  },
  {
    icon: css,
    name: 'CSS3',
    level: '100',
  },
  {
    icon: javascript,
    name: 'Javascript ES7',
    level: '100',
  },
  {
    icon: react1,
    name: 'React',
    level: '100',
  },
  {
    icon: sass,
    name: 'Sass',
    level: '100',
  },
  {
    icon: bootstrap,
    name: 'Bootstrap',
    level: '100',
  },
];

const tools = [
  {
    icon: material,
    name: 'Material UI',
    level: '100',
  },
  {
    icon: git,
    name: 'Git',
    level: '100',
  },
  {
    icon: figma,
    name: 'Figma',
    level: '100',
  },
  {
    icon: redux,
    name: 'Redux',
    level: '100',
  },
  {
    icon: router,
    name: 'React Router',
    level: '100',
  },
  {
    icon: axios,
    name: 'Axios',
    level: '100',
  },
];

export { tools, languages };
